import $ from 'jquery';
import slick from 'slick-carousel';

var galleries = $( '.js-gallery' );

if ( galleries.length > 0 ) {
	galleries.each( function() {
		const color = ( typeof $( this ).attr( 'data-gallery-arrow-color' ) === 'undefined' ) ? '' : $( this ).attr( 'data-gallery-arrow-color' );

		$( this ).slick( {
			infinite: true,
			slidesToShow: 1,
			dots: true,
			fade: true,
			rows: 0,
			mobileFirst: true,
			arrows: false,
			prevArrow: '<button type="button" class="slick-prev ' + color + '"><svg width="32" height="34" viewBox="0 0 32 34" xmlns="http://www.w3.org/2000/svg"><path d="M31 16.286H2.429M16.714 32L1.537 16.286m.019 0L16.152 2" stroke="currentColor" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="square"/></svg></button>',
			nextArrow: '<button type="button" class="slick-next ' + color + '"><svg width="32" height="34" viewBox="0 0 32 34" xmlns="http://www.w3.org/2000/svg"><g stroke="currentColor" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M1 16.286h28.571M15.286 32l15.177-15.714M30.444 16.286L15.848 2"/></g></svg></button>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: true,
					},
				},
			],
		} );
	} );
}
